import { Box } from "@mui/material";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import { Scroller } from "../components/Scroller.js";
import React, { useCallback, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { Segment1 } from "./slides/Segment1.js";
import { Audience1 } from "./slides/Audience1.js";
import { Reach2 } from "./slides/Reach2.js";
import { Platform3a } from "./slides/Platform3a.js";
import { Info4 } from "./slides/Info4.js";
import { User5 } from "./slides/User5.js";
import { Intro0 } from "./slides/Intro0.js";
import { Hero0 } from "./slides/Hero0.js";
import CrosspixelNext from "../pages/CrosspixelNext.js";

const isHero = process.env.REACT_APP_HERO === "true";


const Form = ({ loginStatus, setLoginStatus }) => {

    const [interstitial, setInterstitial] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [cookie, setCookie] = useState({ checked: false });
    const [next, setNext] = useState(false);
    const [activeField, setActiveField] = useState(0); //field by number


    let methods = useForm();

    useForm({
      defaultValues: {
        platforms: {}
      }
    });

    const values = useCallback(async () => {

      const body = {
        account: { token: localStorage.token, email: localStorage.email }
      };

      try {
        const response = await fetch("/data", {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body)
        });

        if (response.ok) {
          // Handle successful response (200-299 status codes)
          const data = await response.json();
          if (activeField === 3) { // Don't update platforms once the platform page has been passed (to prevent overwriting fields)
            if (data && data.platforms) {
              const platforms = methods.getValues(["platforms"])[0];
              for (let plat in platforms) {
                if (data.platforms[plat] && data.platforms[plat].cookie) {
                  methods.setValue(`platforms.${plat}.checked`, data.platforms[plat].checked, { shouldTouch: true });
                  methods.setValue(`platforms.${plat}.cookie`, data.platforms[plat].cookie, { shouldTouch: true });
                }
                if (data.platforms[plat] && data.platforms[plat].next) {
                  methods.setValue(`platforms.${plat}.next`, data.platforms[plat].next, { shouldTouch: true });
                }
              }
            }
          }
          else if (activeField === 2) {
            if (data && data.platforms) {
              methods.setValue("platforms", data.platforms);
            }

            if (data.platforms["The Trade Desk"] && data.platforms["The Trade Desk"].next) {
              methods.setValue(`platforms.${"The Trade Desk"}.next`, data.platforms["The Trade Desk"].next, { shouldTouch: true });

              if (!data.platforms["The Trade Desk"].cookie) {
                methods.setValue(`platforms.${"The Trade Desk"}.checked`, false, { shouldTouch: true });
              }
            }
          }
          else if (activeField < 2)
          {
            if (data && data.platforms) {
              methods.setValue("platforms", data.platforms);
              if (!data.platforms["The Trade Desk"].cookie) {
                methods.setValue(`platforms.${"The Trade Desk"}.checked`, false, { shouldTouch: true });
              }
            }
          }
        } else if (response.status === 401) {
          setLoginStatus({ auth: false, email: null, token: null });
        } else if (response.status === 404) {
          // Handle 404 Not Found error
          console.log("Resource not found.");
        } else if (response.status === 500) {
          // Handle 500 Internal Server Error
          console.log("Internal server error.");
        } else {
          // Handle other error statuses
          console.log("An error occurred:", response.status);
        }
      } catch (error) {
        // Handle network or other general errors
        console.log("An error occurred:", error);
      }

    }, [activeField]);

    useEffect(() => {
      values();
    }, [loginStatus.auth]);

    useEffect(() => {
      const shownInterstitial = localStorage.getItem("interstitial");
      if (shownInterstitial !== "true") {
        localStorage.setItem("interstitial", "true");
        setInterstitial(false);
      } else {
        setInterstitial(true);
      }
    }, []);

    const preventDefaultTab = (e) => {
      if (e.keyCode === 9) {
        e.preventDefault();
        return false;
      }
    };

    const disableTab = () => {
      window.addEventListener("keydown", preventDefaultTab, false);
    };

    useEffect(() => {
      disableTab();
    }, [disableTab]);


    const navigate = useNavigate();
    const [errorState, setErrorState] = useState(false);

    const saveForm = async (data) => {
      const form = new FormData();
      Object.keys(data).forEach((field, i) => {
        //form.append(field, data[field]);
        if (field === "platforms") {
          form.append(field, JSON.stringify(data[field]));
          //form.append(field, data[field]);
          //console.log(`FILTER: ${field} ${data[field]}`);
          //console.log(`FILTER: ${field} ${data[field]}`);
        } else if (field === "passwordOptional") {
          form.append("password", data[field]);
        } else if (field === "segments") {
          form.append(field, JSON.stringify(data[field]));
        } else {
          form.append(field, data[field]);
          //form.append(field, JSON.stringify(data[field]));
        }
        //console.log(`FILTER: ${field} ${JSON.stringify(data[field])}`);
      });

      if (loginStatus && loginStatus.auth) {
        form.append("account", JSON.stringify({ token: localStorage.token, email: localStorage.email }));
      }

      return await fetch("/submit", {
        method: "post",
        body: form
      });
    };


    const onSubmit = async (data, e) => {
      if (submitted) {
        return;
      }
      setSubmitted(true);
      e.preventDefault();

      if (data.passwordOptional) {
        if (data.passwordOptional !== data.confirmOptional) {
          methods.setError("confirm", { message: "Passwords don't match" });
          setErrorState(true);
        }
      }

      let valid;
      if (data.email) {
        valid = await fetch("/validation", {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: data.email })
        }).then((response) => response.json()
        ).catch((e) => {
          console.log(e);
          return false;
        });

        if (!valid || valid.userExists) {
          methods.setError("email", { message: "An account for this email already exists" });
          setErrorState(true);
        }
      }

      if (!data.email || (valid && !valid.userExists)) {

        await saveForm(data)
          .then((response) => {
            return response.status;
          })
          .then((status) => {
            if (status === 200) {
              navigate("/thanks");
            } else if (status === 401) {
              setLoginStatus({ auth: false, email: null, token: null });
              setSubmitted(false);
            } else if (status === 409) {
              navigate("/duplicate");
            } else {
              navigate("/error");
              throw new Error("Failed to Submit Form");
            }
          })
          .catch((e) => {
            //TODO: Something went wrong page?
            console.log("SOMETHING WENT WRONG");
            console.log(e);
          });
      }
    };


    /*useEffect(() => {
      // you can do async server request and fill up form
      setTimeout(() => {
        methods.reset();
      }, 2000);
    }, [methods.reset])*/

    return (
      <Box
        sx={{
          display: interstitial === false ? "" : "flex",
          flexDirection: interstitial === false ? "" : "row",
          m: 0
        }}>
        <ToastContainer />
        {interstitial === false ? <CrosspixelNext setInterstitial={setInterstitial} /> :
          <FormProvider {...methods} >
            <form
              id="siteForm"
              onSubmit={methods.handleSubmit(onSubmit)}>
              {isHero ? <Scroller loginStatus={loginStatus.auth}>
                  <Hero0 />
                  <Segment1 />
                  <Reach2 />
                  <Platform3a />
                  <Info4 />
                  <User5 guestOnly={true} />
                </Scroller>
                :
                <Scroller cookieSelected={cookie.checked} loginStatus={loginStatus.auth}
                          activeField={activeField} setActiveField={setActiveField}>
                  <Intro0 />
                  <Audience1 />
                  <Reach2 setCookie={setCookie} setNext={setNext} />
                  <Platform3a showCookie />
                  <Info4 />
                  <User5 guestOnly={true} />
                </Scroller>
              }
            </form>
          </FormProvider>}
      </Box>
    );
  }
;

export default Form;
